/**
 * dealCategories.js — SINGLE SOURCE OF TRUTH for deal categories (JS side)
 * ========================================================================
 * Location: src/utils/dealCategories.js
 *
 * ⚠️ THIS FILE MIRRORS api/phone-agents-2/deal_tagger.py (CATEGORY_IDS).
 * Same hand-sync rule as statusConstants.js / status_constants.py: if you
 * add or rename a category in one, change the other in the same commit.
 *
 * ids are persisted in marketing_designs.deal_category and matched verbatim
 * by the voice agent's deal menu — never rename an id that live deals use
 * without a data migration.
 */

export const DEAL_CATEGORIES = [
  { id: "mattresses",              label: "Mattresses" },
  { id: "bedroom",                 label: "Bedroom" },
  { id: "sofas_sectionals",        label: "Sofas & Sectionals" },
  { id: "living_room",             label: "Living Room" },
  { id: "recliners_chairs",        label: "Recliners & Chairs" },
  { id: "dining",                  label: "Dining" },
  { id: "office",                  label: "Office" },
  { id: "outdoor",                 label: "Outdoor" },
  { id: "kids",                    label: "Kids" },
  { id: "rugs_decor",              label: "Rugs & Decor" },
  { id: "appliances_electronics",  label: "Appliances & Electronics" },
  { id: "storewide",               label: "Storewide / Clearance" },
  { id: "other",                   label: "Other" },
];

export const DEAL_CATEGORY_IDS = DEAL_CATEGORIES.map((c) => c.id);

const _labelById = Object.fromEntries(
  DEAL_CATEGORIES.map((c) => [c.id, c.label])
);

/** Display label for a stored category id ('' / unknown → 'Untagged'). */
export const dealCategoryLabel = (id) => _labelById[id] || "Untagged";